import {
  Route as RouterRoute,
  Routes as RouterRoutes,
  useLocation,
} from 'react-router-dom';
import propTypes from 'prop-types';

import Page from '../Page';
import AuthPage from '../AuthPage';
import StatsPage from '../StatsPage';
import AdminDashboard from '../AdminDashboard';

const Routes = ({ role }) => {
  const location = useLocation();

  return (
    <RouterRoutes location={location}>
      <RouterRoute
        path="/auth"
        element={<AuthPage />}
      />
      <RouterRoute
        path="/"
        element={<Page />}
      >
        <RouterRoute
          index
          element={<AdminDashboard />}
        />
        {role === 'superAdmin' && (
          <RouterRoute
            path="/stats"
            element={<StatsPage />}
          />
        )}
      </RouterRoute>
    </RouterRoutes>
  );
};

Routes.propTypes = {
  role: propTypes.string,
};

export default Routes;
